<template>
  <div id="app">
    <meta name="viewport" content="width=device-width,initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no">
    <router-view name="header"></router-view>
    <main>
      <fade-transition origin="center" mode="out-in" :duration="250">
       <router-view :key="key"> </router-view>
      </fade-transition>
    </main>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
  import { FadeTransition } from "vue2-transitions";
  export default {
    components: {
      FadeTransition
    },
    computed: {
        key() {
          return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
        }
      }
  };
</script>

<style scoped>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  /* font-family: SourceHanSansCN-ExtraLight; */
  /*font: 16px/1.3 spectral-R, Tahoma, Helvetica, Arial;*/
  font: 16px/1.3 PingFang HK;
  color: #21042e;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  /*color: #2c3e50; */
  /* margin-top: 60px; */
  width: 100%;
  height: 100%;
  position: relative;
  list-style: none;
}
body {
  padding-right: 0 !important;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue